
import common from './ja_JP/common'
import areaCode from './ja_JP/areaCode'
import communicateCenter from './ja_JP/communicateCenter'
import components from './ja_JP/components'
import course from './ja_JP/course'
import courseDetail from './ja_JP/courseDetail'
import examDetail from './ja_JP/examDetail'
import home from './ja_JP/home'
import humanTraining from './ja_JP/humanTraining'
import inforList from './ja_JP/inforList'
import Information from './ja_JP/Information'
import intelligentOfficialDoc from './ja_JP/intelligentOfficialDoc'
import knowledgeLib from './ja_JP/knowledgeLib'
import LearnRecords from './ja_JP/LearnRecords'
import Login from './ja_JP/Login'
import myCourse from './ja_JP/myCourse'
import myExam from './ja_JP/myExam'
import mynews from './ja_JP/mynews'
import mySetting from './ja_JP/mySetting'
import mytopic from './ja_JP/mytopic'
import myTrainingClass from './ja_JP/myTrainingClass'
import myTrainingDetail from './ja_JP/myTrainingDetail'
import myWork from './ja_JP/myWork'
import post from './ja_JP/post'
import postDetail from './ja_JP/postDetail'
import practiceTrain from './ja_JP/practiceTrain'
import publicExam from './ja_JP/publicExam'
import questionnaire from './ja_JP/questionnaire'
import rules from './ja_JP/rules'
import search from './ja_JP/search'
import studyMap from './ja_JP/studyMap'
import topic from './ja_JP/topic'
import topicDetail from './ja_JP/topicDetail'
import topicManagerRange from './ja_JP/topicManagerRange'
import trainingClass from './ja_JP/trainingClass'
import trainingCourseDetail from './ja_JP/trainingCourseDetail'
import webLive from './ja_JP/webLive'

export default {
  ...common,
  ...areaCode,
  ...communicateCenter,
  ...components,
  ...course,
  ...courseDetail,
  ...examDetail,
  ...home,
  ...humanTraining,
  ...inforList,
  ...Information,
  ...intelligentOfficialDoc,
  ...knowledgeLib,
  ...LearnRecords,
  ...Login,
  ...myCourse,
  ...myExam,
  ...mynews,
  ...mySetting,
  ...mytopic,
  ...myTrainingClass,
  ...myTrainingDetail,
  ...myWork,
  ...post,
  ...postDetail,
  ...practiceTrain,
  ...publicExam,
  ...questionnaire,
  ...rules,
  ...search,
  ...studyMap,
  ...topic,
  ...topicDetail,
  ...topicManagerRange,
  ...trainingClass,
  ...trainingCourseDetail,
  ...webLive
}
